import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import ScrollReveal from "scrollreveal";
import firstImage from "../../assets/FirstImage.webp";
import heroOne from "../../assets/heroOne.webp";
import heroThree from "../../assets/heroThree.webp";
import heroTwo from "../../assets/heroTwo.webp";
import PopUpJoinUs from "../PopUpJoinUs/PopUpJoinUs";
import styles from "./introduction.module.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function Introduction() {
  const imageRef = useRef(null);
  const sectionRef = useRef(null);
  const [session, setSession] = useState(JSON.parse(localStorage.getItem("user_stu") || "{}"));

  const screenWidth = window.innerWidth;


  const { t } = useTranslation();
  useEffect(() => {
    const sr = ScrollReveal();
    sr.reveal(imageRef.current, {
      duration: 900,
      distance: screenWidth < 768 ? "0px" : "70px",
      easing: "ease-in",
      origin: "left",
      reset: true,
    });
    sr.reveal(sectionRef.current, {
      duration: 900,
      distance: screenWidth < 768 ? "0px" : "70px",
      easing: "ease-in",
      origin: "right",
      reset: true,
    });
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <div className={`${styles.heroSection}continer my-5`}>
        <div className="row d-flex justify-content-around m-auto ">
          <div
            className="col-lg-6 col-md-12 d-flex flex-column my-4 introdaction-space"
            ref={sectionRef}
          >
            <h1
              className={`mx-1 ${styles.h1_intro_font_mobile} ${styles.h1_intro_font}`}
            >
              {t("Learn. Develop. Work")}
            </h1>
            <h1
              className={`${styles.h1_intro_font_mobile} ${styles.h1_intro_font}`}
            >
              {t("With")} EYouth Learning
            </h1>
            <p className={`mx-1 h5 ${styles.p_intro_font}`}>
              {t(
                "The leading educational platform in the MENA region since 2016"
              )}
            </p>
            <h2 className={`mt-3 ${styles.intro_font}`}>
              {t(
                "Educational programs that will change your career for the better"
              )}
            </h2>
            <p className={styles.p_intro}>
              <LazyLoadImage alt="icon" className="ms-2" src={heroOne} />
              {t("learn new skills")}
            </p>
            <p className={styles.p_intro}>
              <LazyLoadImage alt="icon" className="ms-2" src={heroTwo} />

              {t("Learn with experts")}
            </p>
            <p className={styles.p_intro}>
              <LazyLoadImage alt="icon" className="ms-2" src={heroThree} />
              {t("Work in your field")}
            </p>
            {Object.keys(session).length === 0 && (
              <div className={` ${styles.joinUsDiv} d-flex mt-auto`}>
                <PopUpJoinUs
                  title={t("Join_Us_Now")}
                  styles={`btn btn-primary ${styles.button_joinUs_home_Mobile} ${styles.button_joinUs_home}`}
                />{" "}
              </div>
            )}
          </div>
          <div
            className={`col-lg-4 col-md-12 ${styles.image_move_Mobile} ${styles.image_move}`}
            ref={imageRef}
          >
            {/* <LazyLoadImage src={image1} className={styles.imageClassMobile} alt="hero-section" /> */}
            <LazyLoadImage
              src={firstImage}
              className={styles.imageClassMobile}
              alt="hero-section"
            />
          </div>
        </div>
      </div>
    </>
  );
}
